import React from 'react';
import { Container } from 'reactstrap';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import DietCarousel01 from './diet-carousel-01.svg';
import DietCarousel02 from './diet-carousel-02.svg';
import DietCarousel03 from './diet-carousel-03.svg';
import DietCarousel04 from './diet-carousel-04.svg';
// import closeX from './closex.svg';
// import { onFinishedWebView, sendFirebaseEvent } from '../../../helper/mobile';
import RequestCallBack from '../../../component/RequestCallBack';

const DietPlanMainHeader = () => {

    // const onClickHandler = () => {
    //     sendFirebaseEvent('diet_plan_main_page_close', 'click_event');
    //     onFinishedWebView();
    // }
    
    return (
        <>
        <Container className='diet-plan-main-header pb-4'>
            {/* <img onClick={onClickHandler} src={closeX} alt='' className='diet-plan-main-header-close-btn' /> */}
            <Carousel className='mb-3' interval={5000} autoPlay={true} infiniteLoop={true} dynamicHeight={true} showArrows={false} showStatus={false} showThumbs={false}>
                <div>
                    <img src={DietCarousel01} alt="" />
                </div>
                <div>
                    <img src={DietCarousel02} alt="" />
                </div>
                <div>
                    <img src={DietCarousel03} alt="" />
                </div>
                <div>
                    <img src={DietCarousel04} alt="" />
                </div>
            </Carousel>
            <RequestCallBack pageType='main' />
        </Container>
    </>
    );
}

export default DietPlanMainHeader;